export default __webpack_public_path__ + "static/media/2024_Simha_et_al_2024_BulletinESA.15fab5c2.pdf";